import ApplicationApiCall from './functions/application-api-call';
import Util from "./helpers/Util";
import Cache from "./helpers/Cache";
import ShopifySetting from "./components/shopify_setting";
import ShopifyHelper from "./helpers/ShopifyHelper";
import CsI18n from "./components/csI18n";

export const DEV_MODE = {
  DEV: 'dev',
  PROD: 'prod'
};

export const TAB = {
  MAIN_TAB: 1,
  CHILD_TAB1: 2,
  CHILD_TAB2: 3,
}

export const amazon_platforms = [
  {value: 'ATVPDKIKX0DER', label: 'Amazon USA', iso_code: 'us'},
  {value: 'A2Q3Y263D00KWC', label: 'Amazon Brazil', iso_code: 'br'},
  {value: 'A2EUQ1WTGCTBG2', label: 'Amazon Canada', iso_code: 'ca'},
  {value: 'A1AM78C64UM0Y8', label: 'Amazon Mexico', iso_code: 'mx'},

  {value: 'A13V1IB3VIYZZH', label: 'Amazon France', iso_code: 'fr'},
  {value: 'A1RKKUPIHCS9HS', label: 'Amazon Spain', iso_code: 'es'},
  {value: 'A1PA6795UKMFR9', label: 'Amazon Germany', iso_code: 'de'},
  {value: 'APJ6JRA9NG5V4', label: 'Amazon Italy', iso_code: 'it'},
  {value: 'A1F83G8C2ARO7P', label: 'Amazon United Kingdom', iso_code: 'uk'},
  {value: 'A1805IZSGTT6HS', label: 'Amazon Netherlands', iso_code: 'nl'},
  {value: 'A2NODRKZP88ZB9', label: 'Amazon Sweden', iso_code: 'se'},
  {value: 'A33AVAJ2PDY3EV', label: 'Amazon Turkey', iso_code: 'tr'},
  {value: 'A2VIGQ35RCS4UG', label: 'Amazon United Arab Emirates (U.A.E.)', iso_code: 'ae'},
  {value: 'A21TJRUUN4KGV', label: 'Amazon India', iso_code: 'in'},
  {value: 'A17E79C6D8DWNP', label: 'Amazon Saudi Arabia', iso_code: 'sa'},
  {value: 'A1C3SOZRARQ6R3', label: 'Amazon Poland', iso_code: 'pl'},
  {value: 'ARBP9OOSHTCHU', label: 'Amazon Egypt', iso_code: 'eg'},
  {value: 'AMEN7PMS3EDWL', label: 'Amazon Belgium', iso_code: 'be'},
  {value: 'AE08WJ6YKNBMC', label: 'Amazon South Africa', iso_code: 'za'},
  {value: 'A28R8C7NBKEWEA', label: 'Amazon Ireland', iso_code: 'ie'},

  {value: 'A1VC38T7YXB528', label: 'Amazon Japan', iso_code: 'jp'},
  {value: 'A39IBJ37TRP1C6', label: 'Amazon Australia', iso_code: 'au'},
  {value: 'A19VAU5U5O7RUS', label: 'Amazon Singapore', iso_code: 'sg'},
  {value: 'AAHKV2X7AFYLW', label: 'Amazon China', iso_code: 'cn'},
];

export const amazon_regions = [
  {
    value: 'na',
    label: 'North America region (including the US, Canada, Mexico, and Brazil)',
    available: true
  },
  {
    value: 'eu',
    label: 'Europe region (including the Spain, UK, France, Netherlands, Germany, Italy, Sweden, Poland, Saudi Arabia, Egypt, Turkey, U.A.E., India, Belgium, South Africa, Ireland)',
    available: true
  },
  {
    value: 'east',
    label: 'Far East region (including the Singapore, Australia, Japan)',
    available: true
  }
];

const COURSE_FULL = 1;
const COURSE_LIMITED = 2;

class ShopifyContext {
  static shared = null;

  static console_log = null;
  static console_info = null;
  static console_error = null;
  static console_warn = null;

  /**
   *
   * @returns ShopifyContext
   */
  static getShared() {
    if (ShopifyContext.shared == null) {
      ShopifyContext.shared = new ShopifyContext();
    }
    return ShopifyContext.shared;
  }

  constructor() {

    this.store_properties = null;
    this.money_format = "{{amount}}";

    let shopify_settings = ShopifySetting.getShared();

    this.amazon_platforms = amazon_platforms;

    this.dev = shopify_settings.dev;
    this.api_url = shopify_settings.api_url;
    this.static_content = shopify_settings.static_content;
    this.version = shopify_settings.version;
    this.domain = shopify_settings.domain;
    this.shop_domain = shopify_settings.shop_domain;
    this.api_key = shopify_settings.api_key;
    this.store = shopify_settings.store;
    this.admin_store = '';
    this.lang = "en" //default value
    this.admin = false;
    this.section_data = {};
    this.shop = '';
    this.amazon = '';
    this.amazon_default = null;
    this.selectedConfiguration = 0;
    this.store_billing_info = null;
    this.store_tab = null;
    this.demo_mode = false;
    this.remaining_order_count = 0;

    this.dev_mode = shopify_settings.dev ? DEV_MODE.DEV : DEV_MODE.PROD;
    this.params = new URLSearchParams(window.location.search);
    let shopify_host = this.params.get('host');
    let cs_host = this.params.get('cs_host');
    if (!shopify_host) {
      shopify_host = cs_host;
    }
    if (!shopify_host && this.dev) {
      shopify_host = "a2J1Z3N0b3JlLm15c2hvcGlmeS5jb20vYWRtaW4";
    }
    this.shopify_host = shopify_host;

    this.shopify_params = [];
    for (const [key, value] of this.params.entries()) {
      if (key === 'redirect' || key.search('param_') !== -1) {
        continue;
      }
      this.shopify_params.push({key, value});
    }

    this.plan_data = {};
    this.advanced_options = {};
    this.plan_prices = {};
    this.plan_descriptions = {};
    //console.log("context shopify_params", this.shopify_params);
  }

  isDevMode() {
    if (this.dev_mode == DEV_MODE.DEV) {
      return true;
    }
    return false;
  }

  setDisableConsoleLog() {
    if (!ShopifyContext.console_log) {
      ShopifyContext.console_log = window['console']['log'];
      ShopifyContext.console_info = window['console']['info'];
      ShopifyContext.console_error = window['console']['error'];
      ShopifyContext.console_warn = window['console']['warn'];
    }

    if (!this.isDevMode()) {
      let nulfunc = function () {
      };
      window['console']['log'] = nulfunc;
      window['console']['info'] = nulfunc;
      // window['console']['error'] = nulfunc; //please don't disable for tracking
      window['console']['warn'] = nulfunc;
    }
  }

  setEnableConsoleLog() {
    window['console']['log'] = ShopifyContext.console_log;
    window['console']['info'] = ShopifyContext.console_info;
    window['console']['error'] = ShopifyContext.console_error;
    window['console']['warn'] = ShopifyContext.console_warn;
  }

  getCacheNs() {
    if (this.admin && this.store != this.admin_store) {
      return `admin_${this.store}`;
    } else {
      return this.store;
    }
  }

  getShopifyHost() {
    return this.shopify_host;
  }

  getStoreDomain() {
    return this.shop_domain;
  }

  getStoreName() {
    return this.store_properties ? this.store_properties.name : '';
  }

  isAdminMode() {
    return (this.admin);
  }

  isDemoMode() {
    return this.demo_mode;
  }

  init_admin() {
    if (this.store_properties.hasOwnProperty('user_admin')) {
      this.admin = this.store_properties.user_admin;
    }
  }

  init() {
    this.store_properties = Cache.getCachedStoreInfo('store_properties');

    if (this.store_properties.hasOwnProperty('user_language')) {
      this.lang = this.store_properties.user_language;
    }

    this.money_format = ShopifyHelper.parseMoneyFormat(this.store_properties.money_format);

    let params = new URLSearchParams(decodeURIComponent(window.location.search));
    let locale = params.get('locale') || "";
    let lang = (locale.length > 2) ? locale.slice(0, 2) : "";
    if (lang) {
      this.lang = lang;
    }
    console.log("init", window.location.search, locale, lang);

    this.demo_mode = !!this.store_properties.demo_mode;
    this.store_tab = Util.getPathName();
    console.log("init: ", this.store_tab);
  }

  changeStore(newStore) {
    ShopifySetting.getShared().store = newStore;
    this.store = newStore;
    this.amazon = [];
  }

  isLimited() {
    return this.store_properties.course_type == COURSE_LIMITED;
  }

  //load data
  initStoreData(callback, forceReset = false) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loadDataBase54 = urlParams.get('load_data');
    let loadData;

    if (loadDataBase54 === null || forceReset) {
      loadData = Cache.getCachedStoreInfo('init_data');
      console.log('init data from Cache', loadData);
    } else {
      const loadDataJson = atob(loadDataBase54);
      loadData = JSON.parse(loadDataJson);
      console.log('loadData', loadData);
    }

    if (loadData) {
      console.log('initStoreData from cache');
      this.initConfiguration(loadData);
      this.init();
      this.init_admin();
      callback(loadData);
    } else {
      console.log('initStoreData from server');
      this.fetchStoreData(callback, true);
    }
  }

  fetchStoreData(callback, bFirst = false) {
    let params = {};
    ApplicationApiCall.get('/application/home/load_data', params, (result) => {
      console.log("fetchStoreProperties", result);
      if (result) {
        Cache.setCachedStoreInfo('init_data', result);
        this.initConfiguration(result);
        this.init();
        if (bFirst) {
          this.init_admin();
        }
      }
      callback(result)
    });
  }

  initConfiguration(data) {
    Cache.setCachedStoreInfo('store_properties', data.shop);
    Cache.setSession(this.getCacheNs(), Cache.name_configuration_list, data.settings);
    Cache.setSession(this.getCacheNs(), Cache.name_setting_status, data.configuration_workflow);

    this.amazon = data.settings;
    this.configuration_setting_status = data.configuration_workflow;
    this.remaining_order_count = data.remaining_order_count;
    this.setAmazonDefault(data.configuration_default);
    this.initConfigurationSelect();

    this.setPlanData(data);
  }

  isValidConfiguration(configuration) {
    if (!this.amazon) {
      return false;
    }
    for (let i in this.amazon) {
      if (this.amazon[i].configuration == configuration)
        return true;
    }
    return false;
  }

  setAmazonDefault(configuration) {
    if (typeof (configuration) == "string" && this.isValidConfiguration(configuration)) {
      this.amazon_default = configuration;

      // sessionStorage.setItem(this.store +'_amazon_default', param);
      Cache.setSession(this.getCacheNs(), Cache.name_configuration_default, configuration);
    }
    console.log('setAmazonDefault', this.amazon_default)
  }

  deleteConfiguration(index) {
    if (index >= this.amazon.length)
      return;
    this.amazon.splice(index, 1);
  }

  editConfiguration = (configuration, field, value) => {
    this.amazon.forEach(item => {
      if (item.configuration === configuration) {
        item[field] = value;
      }
    });
  }

  setStoreTab(tab) {
    console.log("setStoreTab", tab);
    this.store_tab = tab;
  }

  getTab(index) {
    if (this.store_tab instanceof Array) {
      return this.store_tab[index];
    } else {
      return this.store_tab;
    }
  }

  initTabData(section, params) {
    console.log('initTabData', params)

    if (params && params.settings) {
      this.section_data[section] = [];

      // Init tabs
      if (!this.amazon) {
        return;
      }

      for (let row of params.settings) {
        if (row && row.configuration) {
          this.section_data[section][row.configuration] = row;
        }
      }
    }
    console.log(this.section_data);
  }

  redirect(cbSuccess, cbError = null) {
    let searchParams = new URLSearchParams(decodeURIComponent(window.location.search));
    let id = searchParams.get('id');
    let shop = searchParams.get('shop');
    let configuration = 'global';

    let params = {id, shop, configuration};

    ApplicationApiCall.get('/link/order/view', params
      , (json) => {
        if (cbSuccess) {
          cbSuccess(json);
        }
      }
      , (err) => {
        if (err && cbError) {
          cbError(err);
        }
      })
  }

  getAppBaseUrl() {
    // return "http://localhost/click/public/test";
    return "https://" + this.domain + "/admin/apps/" + process.env.REACT_APP_NAME;
  }

  getShopUrl() {
    if (this.domain.search("http") === 0) {
      return this.domain;
    } else {
      return "https://" + this.domain;
    }
  }

  getMoneyStringWithStoreFormat(price, fractionDigists = 2) {
    if (isNaN(price)) {
      return "";
    }

    if (price % 1 !== 0) {
      price = parseFloat(price).toFixed(fractionDigists);
    } else {
      price = parseInt(price);
    }
    let format = this.money_format;
    return format.replace(/{.*}/, price);
  }

  initConfigurationSelect() {
    this.setConfigurationSelectedIndex(this.getDefaultConfigurationSelectedIndex());
  }

  setConfigurationSelectedIndex(index) {
    let cache_name = Cache.makeCacheName(Cache.type_setting, 'selectedConfiguration');
    Cache.setCachedParameter(cache_name, index, Cache.CACHE_FOREVER);
  }

  getConfigurationSelectedIndex() {
    let cache_name = Cache.makeCacheName(Cache.type_setting, 'selectedConfiguration');
    let selectedConfiguration = Cache.getCachedParameter(cache_name);
    if (selectedConfiguration === null) {
      selectedConfiguration = this.getDefaultConfigurationSelectedIndex();
      this.setConfigurationSelectedIndex(selectedConfiguration);
    }
    return (selectedConfiguration);
  }

  getConfigurationSelected() {
    return this.getConfiguration(this.getConfigurationSelectedIndex());
  }

  hasAccounts() {
    return this.amazon && this.amazon.length > 0;
  }

  getConfiguration(index) {
    if (!this.amazon || this.amazon.length === 0 || this.amazon.length < index || index === null) {
      return false;
    }
    if (this.amazon[index]) {
      return this.amazon[index].configuration;
    }
    return false;
  }

  getAccountSelected() {
    return this.getAccount(this.getConfigurationSelectedIndex());
  }

  getAccount(index) {
    if (!this.amazon || this.amazon.length === 0 || this.amazon.length < index || index === null) {
      return false;
    }
    return this.amazon[index];
  }

  getDefaultConfigurationSelectedIndex() {
    // let currentlySelected = sessionStorage.getItem(this.shopify.store +'_amazon_selected');
    let currentlySelected = Cache.getSession(this.getCacheNs(), Cache.name_configuration_selected);
    if (currentlySelected !== null) {
      return (parseInt(currentlySelected));
    }
    for (let i = 0; i < this.amazon.length; i++) {
      if (this.amazon[i].configuration == this.amazon_default)
        return i;
    }
    return 0;
  }

  getSelectedFeatures(configuration) {
    if (!this.configuration_setting_status) {
      return false;
    }
    for (let i in this.configuration_setting_status) {
      if (this.configuration_setting_status[i].configuration == configuration) {
        return this.configuration_setting_status[i].selected_features;
      }
    }
    return false;
  }

  //isSettingFinished
  getSettingError() {
    let configuration = this.getConfigurationSelected();
    let selected_features = this.getSelectedFeatures(configuration);
    console.log("getSettingError", selected_features);

    if (!this.configuration_setting_status) {
      return 1;
    }
    for (let i in this.configuration_setting_status) {
      if (this.configuration_setting_status[i] && this.configuration_setting_status[i].configuration == configuration) {
        if (!this.configuration_setting_status[i].hasOwnProperty('is_exist_scheduler') || !this.configuration_setting_status[i].is_exist_scheduler) {
          return 1;
        }

        if (!this.configuration_setting_status[i].hasOwnProperty('selected_marketplaces') || !this.configuration_setting_status[i].selected_marketplaces) {
          return 2;
        }

        if (!this.configuration_setting_status[i].locations) {
          return 3;
        }

        if (!this.configuration_setting_status[i].collections) {
          return 4;
        }
        return 0; //setting DONE
      }
    }
    return 1;
  }

  updateSettingStatus(configuration, field, status) {
    if (!this.configuration_setting_status) {
      this.configuration_setting_status = [];
    }
    let bFound = false;
    for (let i in this.configuration_setting_status) {
      if (this.configuration_setting_status[i].configuration == configuration) {
        this.configuration_setting_status[i][field] = status;
        bFound = true;
        break;
      }
    }
    if (!bFound) {
      this.configuration_setting_status.push({configuration: configuration, [field]: status});
    }
    Cache.setSession(this.getCacheNs(), Cache.name_setting_status, this.configuration_setting_status);
    return true;
  }

  //Don't remove for product import
  isAllowedFeature(feature) {
    if (!feature || feature === 'any') {
      return true;
    }
    let index = this.getConfigurationSelectedIndex();
    let configuration = this.getConfiguration(index);
    if (!configuration) {
      return false;
    }
    let selected_features = this.getSelectedFeatures(configuration);
    console.log("isAllowedFeature", feature, selected_features);
    return (selected_features && selected_features.length > 0 && selected_features.indexOf(feature) !== -1);
  }

  //Plan data
  getPlanPrice(plan_type) {
    switch (parseInt(plan_type)) {
      case 1:
        return this.plan_prices.basic;
      case 2:
        return this.plan_prices.advanced;
      case 3:
        return this.plan_prices.pro;
      case 4:
        return this.plan_prices.old_basic;
      case 5:
        return this.plan_prices.old_advanced;
      case 6:
        return this.plan_prices.old_pro;
      default:
        return 0;
    }
  }

  //Plan description
  getPlanDescription(plan_type) {
    switch (parseInt(plan_type)) {
      case 1:
        return this.plan_descriptions.basic;
      case 2:
        return this.plan_descriptions.advanced;
      case 3:
        return this.plan_descriptions.pro;
      case 4:
        return this.plan_descriptions.old_basic;
      case 5:
        return this.plan_descriptions.old_advanced;
      case 6:
        return this.plan_descriptions.old_pro;
      default:
        return this.plan_descriptions.limit;
    }
  }

  setPlanData(data) {
    let {
      course_type: plan_type,
      course_limit: plan_limit,
      course_count: plan_count,
      trial_days,
      plan_info: plan_info,
      advanced_options,
      plan_prices,
      plan_descriptions
    } = data;
    this.plan_data = {plan_type, plan_limit, plan_count, trial_days, plan_info, advanced_options};
    this.plan_prices = plan_prices;
    this.plan_descriptions = plan_descriptions;
    this.setAdvancedOption(advanced_options);
  }

  updatePlanData(plan_data) {
    let {plan_type, plan_limit, plan_count, trial_days, plan_info} = plan_data;
    this.plan_data = {plan_type, plan_limit, plan_count, trial_days, plan_info};
  }

  getPlanData() {
    return this.plan_data;
  }

  hasPlan() {
    return this.plan_data.plan_type && Util.inArray(this.plan_data.plan_type, ['10', '1', '2', '3', '4', '5', '6']);
  }

  setAdvancedOption(data) {
    this.advanced_options = data;
  }

  getAdvancedOption() {
    return this.advanced_options;
  }

  getPlanName() {
    const {plan_type} = this.plan_data;
    if (plan_type === null || plan_type === undefined) {
      return CsI18n.t('No plan');
    }
    switch (parseInt(plan_type)) {
      case 10:
        return CsI18n.t('Free');
      case 1:
      case 4:
        return !this.plan_prices ? CsI18n.t('Basic') : CsI18n.t(this.plan_prices?.basic + '$ Basic');
      case 2:
      case 5:
        return !this.plan_prices ? CsI18n.t('Advanced') : CsI18n.t(this.plan_prices?.advanced + '$ Advanced');
      case 3:
      case 6:
        return !this.plan_prices ? CsI18n.t('Pro') : CsI18n.t(this.plan_prices?.pro + '$ Pro');
      /*case 0:
      case -1:*/
      default:
        return CsI18n.t('No plan');
    }
  }

  isAllowByPlan(tab) {
    if (!tab) {
      return true;
    }
    if (!tab.hasOwnProperty('allowed_plan')) {
      return true;
    }

    let {plan_type} = this.plan_data;
    if (plan_type == 10) {
      plan_type = 0;
    }

    return plan_type >= tab.allowed_plan;
  }

  isProAccount() {
    let {plan_type} = this.plan_data;
    return parseInt(plan_type) === 3;
  }

  disableAddConnection = () => {
    const {plan_type} = this.plan_data;
    return !Util.inArray(plan_type, [2, 3, 5, 6]) && this.amazon.length >= 1;
  }
}

export default ShopifyContext
